import {
  GET_BASIC_BUYER_INFORMATION,
  GET_BASIC_BUYER_INFORMATION_ERROR,
  GET_BASIC_BUYER_INFORMATION_SUCCESS
} from './BasicBuyerInformationSection.actions'

const basicBuyerInformationState = {
  loading: true,
  error: undefined,
  entCode: null,
  orgLegalName: '',
  dni: null,
  orgName: '',
  webSite: null,
  phone: null,
  email: null,
  sector: null,
  orgAddress: null
}

/**
 * The Basic buyer Information reducer.
 */
const basicBuyerInformationReducer = (state = basicBuyerInformationState, { payload, type }) => {
  switch (type) {
    case GET_BASIC_BUYER_INFORMATION: {
      return { ...state, loading: true }
    }
    case GET_BASIC_BUYER_INFORMATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        entCode: payload?.entCode,
        dni: payload?.dni,
        orgLegalName: payload?.orgLegalName,
        orgAddress: payload?.address,
        email: payload?.email,
        orgName: payload?.orgName,
        phone: payload?.phone,
        sector: payload?.sector,
        webSite: payload?.webSite
      }
    }
    case GET_BASIC_BUYER_INFORMATION_ERROR: {
      return { ...state, loading: false, dni: payload.dni, error: payload.error }
    }
    default: {
      return state
    }
  }
}

export default basicBuyerInformationReducer
